/* Taze Gurme — normalize compound technical fields embedded in product descriptions. */
(function () {
  var PRODUCT_SCOPE = '.content-for-layout[data-template^="product"]';
  var PRODUCER_ATTR = 'data-tg-inline-producer';

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanLabel(value) {
    return normalize(value).replace(/^[\s:：\-–—]+|[\s:：\-–—]+$/g, '').trim();
  }

  function classifyLabel(value) {
    var label = cleanLabel(value);
    if (/^(içindekiler|icerik|ingredients)\b/.test(label)) return 'ingredients';
    if (/^(besin değerleri|besin değeri|besin içeriği|besin bilgileri|beslenme değerleri|nutrition)\b/.test(label)) return 'nutrition';
    if (/^(nasıl kullanılır|nasil kullanilir|kullanım önerileri|kullanim onerileri|kullanım|kullanim|hazırlama|hazirlanisi|hazırlanışı|servis önerisi)\b/.test(label)) return 'usage';
    if (/^(alerjen bilgisi|alerjen uyarısı|alerjen uyarisi|alerjenler|alerjen|allergen|allergens)\b/.test(label)) return 'allergen';
    if (/^(saklama koşulları|saklama kosullari|saklama önerisi|saklama onerisi|saklama)\b/.test(label)) return 'storage';
    if (/^(menşei|mensei|menşe|mense|üretim yeri|uretim yeri)\b/.test(label)) return 'origin';
    if (/^(üretici firma|uretici firma|üretici bilgisi|uretici bilgisi|üretici|uretici|manufacturer)\b/.test(label)) return 'producer';
    return null;
  }

  function isInlineBoldLabel(element) {
    if (!element) return false;
    if (/^(STRONG|B)$/.test(element.tagName)) return true;
    if (element.tagName !== 'SPAN') return false;

    var weight = String((element.style && element.style.fontWeight) || '').trim().toLowerCase();
    if (weight === 'bold' || weight === 'bolder') return true;

    var numericWeight = parseInt(weight, 10);
    return Number.isFinite(numericWeight) && numericWeight >= 600;
  }

  function firstLabel(element) {
    if (!element) return null;
    var child = element.firstElementChild;
    if (!isInlineBoldLabel(child)) return null;
    return child;
  }

  function createSegment(source, nodes, index) {
    var clone = source.cloneNode(false);
    if (index > 0) clone.removeAttribute('id');
    nodes.forEach(function (node) {
      clone.appendChild(node.cloneNode(true));
    });

    var label = firstLabel(clone);
    var kind = label ? classifyLabel(label.textContent) : null;
    if (kind === 'producer') {
      var heading = document.createElement('h6');
      Array.prototype.slice.call(clone.childNodes).forEach(function (node) {
        heading.appendChild(node.cloneNode(true));
      });
      heading.setAttribute(PRODUCER_ATTR, 'true');
      return heading;
    }

    return clone;
  }

  function markStandaloneProducer(scope) {
    Array.prototype.slice.call(scope.querySelectorAll('p, div')).forEach(function (element) {
      if (!element.isConnected || element.closest('.tg-product-info-stack')) return;
      var label = firstLabel(element);
      if (!label || classifyLabel(label.textContent) !== 'producer') return;

      if (element.hasAttribute(PRODUCER_ATTR)) return;
      var heading = document.createElement('h6');
      Array.prototype.slice.call(element.childNodes).forEach(function (node) {
        heading.appendChild(node.cloneNode(true));
      });
      heading.setAttribute(PRODUCER_ATTR, 'true');
      if (element.dataset.tgCompoundSplit === 'true') heading.dataset.tgCompoundSplit = 'true';
      element.replaceWith(heading);
    });
  }

  function splitCompoundFields(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var hasProductScope = (root.matches && root.matches(PRODUCT_SCOPE)) ||
      (root.closest && root.closest(PRODUCT_SCOPE)) ||
      root.querySelector(PRODUCT_SCOPE) ||
      document.querySelector(PRODUCT_SCOPE);
    if (!hasProductScope) return;

    var productRoot = (root.matches && root.matches(PRODUCT_SCOPE))
      ? root
      : (root.closest && root.closest(PRODUCT_SCOPE)) || root.querySelector(PRODUCT_SCOPE) || document.querySelector(PRODUCT_SCOPE);
    if (!productRoot) return;

    Array.prototype.slice.call(productRoot.querySelectorAll('.text-block.rte p, .text-block.rte div')).forEach(function (element) {
      if (!element.isConnected || element.closest('.tg-product-info-stack')) return;
      if (element.dataset.tgCompoundSplit === 'true') return;

      var labels = Array.prototype.slice.call(element.querySelectorAll('strong, b, span[style]')).filter(function (label) {
        return isInlineBoldLabel(label) && Boolean(classifyLabel(label.textContent));
      });
      if (labels.length < 2) return;

      var nodes = Array.prototype.slice.call(element.childNodes);
      if (!nodes.some(function (node) { return node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR'; })) return;

      var groups = [];
      var current = [];
      nodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
          if (current.length) {
            groups.push(current);
            current = [];
          }
        } else {
          current.push(node);
        }
      });
      if (current.length) groups.push(current);
      if (groups.length < 2) return;

      var replacements = groups.map(function (group, index) {
        return createSegment(element, group, index);
      }).filter(function (segment) {
        return segment.textContent.replace(/\s+/g, ' ').trim();
      });

      var recognized = replacements.filter(function (segment) {
        var label = firstLabel(segment);
        return Boolean((label && classifyLabel(label.textContent)) || segment.hasAttribute(PRODUCER_ATTR));
      });
      if (recognized.length < 2) return;

      var fragment = document.createDocumentFragment();
      replacements.forEach(function (segment) {
        segment.dataset.tgCompoundSplit = 'true';
        fragment.appendChild(segment);
      });
      element.replaceWith(fragment);
    });

    markStandaloneProducer(productRoot);
  }

  function stripProducerLabel(element) {
    var clone = element.cloneNode(true);
    clone.removeAttribute(PRODUCER_ATTR);
    clone.removeAttribute('data-tg-compound-split');
    var label = firstLabel(clone);
    if (label && classifyLabel(label.textContent) === 'producer') label.remove();
    var html = clone.innerHTML.replace(/^[\s:：\-–—]+/, '').trim();
    var paragraph = document.createElement('p');
    paragraph.innerHTML = html;
    return paragraph;
  }

  function createProducerPanel(entries) {
    var panel = document.createElement('details');
    panel.className = 'tg-product-info-panel tg-product-info-panel--secondary';
    panel.dataset.tgInfoKind = 'producer';

    var summary = document.createElement('summary');
    summary.className = 'tg-product-info-panel__summary';

    var title = document.createElement('span');
    title.className = 'tg-product-info-panel__title';
    title.textContent = 'Üretici';

    var toggle = document.createElement('span');
    toggle.className = 'tg-product-info-panel__toggle';
    toggle.setAttribute('aria-hidden', 'true');

    summary.appendChild(title);
    summary.appendChild(toggle);
    panel.appendChild(summary);

    var content = document.createElement('div');
    content.className = 'tg-product-info-panel__secondary-content';
    entries.forEach(function (entry) {
      content.appendChild(stripProducerLabel(entry));
      entry.remove();
    });
    panel.appendChild(content);
    return panel;
  }

  function placeProducerPanel(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll('.tg-product-description-block')).forEach(function (block) {
      var description = block.matches('.rte') ? block : block.querySelector('.rte');
      if (!description) return;
      var stack = description.querySelector('.tg-product-info-stack');
      if (!stack || stack.querySelector('[data-tg-info-kind="producer"]')) return;

      var entries = Array.prototype.slice.call(description.querySelectorAll('[' + PRODUCER_ATTR + '="true"]')).filter(function (entry) {
        return !entry.closest('.tg-product-info-stack');
      });
      if (!entries.length) return;
      stack.appendChild(createProducerPanel(entries));
    });
  }

  splitCompoundFields(document);

  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(function () { placeProducerPanel(document); }, 0);
  }, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    splitCompoundFields(event.target);
    window.setTimeout(function () { placeProducerPanel(event.target); }, 0);
  });
})();
